// react-native-keep-awake module resolution
export default function awake(){}